import { render, staticRenderFns } from "./formTask.vue?vue&type=template&id=3f586c7e&scoped=true"
import script from "./formTask.vue?vue&type=script&lang=js"
export * from "./formTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f586c7e",
  null
  
)

export default component.exports